import { Grid, Typography } from "@mui/material";
import ContentBox from "src/components/ContentBox/ContentBox";
import { textStyle } from "src/styles/textstyle";
import { AccordionWrapper } from "../../MainPage/Components/StillUnsure";
import { successFullAd } from "src/media/texts/faq_main";

export default function GoodAdvices() {
  return (
    <ContentBox title="" id={"good-advice-2"}>
      <Grid container spacing={5}>
        <Grid item xs={12} md={8}>
          <Typography
            variant="h3"
            sx={{ ...textStyle, fontWeight: "bold", marginBottom: "20px" }}
          >
            How to write a successful home advertisement
          </Typography>
          {successFullAd.map((item, index) => (
            <AccordionWrapper
              key={index}
              question={index + 1 + ". " + item.header}
              answer={item.answer}
              smallVersion={true}
            />
          ))}
        </Grid>
      </Grid>
    </ContentBox>
  );
}
